import { useState } from 'react';
import { AiFillGithub, AiOutlineMenu } from 'react-icons/ai';
import { useNavigate, useLocation } from "react-router-dom";
import Fade from 'react-reveal/Fade';

const TopNavComponent = ({ toggleNav }) => {

    const location = useLocation();
    const navigate = useNavigate();
    const activeOption = location.pathname.split("/")[1].trim().length > 0 ? location.pathname.split("/")[1] : "home"

    return (
        <>
            <div className="h-[100px]  flex items-center px-[30px] gap-[20px] bg-midnight">
                <Fade left duration={1500}>
                    <div className=" basis-[85%] lg:basis-[25%] ">
                        <a href='#' className="cursor-pointer font-poppins text-white text-3xl lg:text-4xl tracking-[0.2rem] font-[500]">mazstar.</a>
                    </div>
                </Fade>
                <div className="hidden lg:block flex-1">
                    <Fade duration={1000} delay={800}>
                        <ul className="list-none flex gap-[40px] text-white text-xl font-[350] font-poppins transition-all duration-500 cursor-pointer">
                            <li className={`${activeOption == "home" ? "border-b-2 border-white font-[500]" : ""} hover:font-[500]`} onClick={() => { navigate("/home") }}>Home</li>
                            <li className={`${activeOption == "portfolio" ? "border-b-2 border-white font-[500]" : ""} hover:font-[500]`} onClick={() => { navigate("/portfolio") }}>Portfolio</li>
                            <li className={`${activeOption == "contact" ? "border-b-2 border-white font-[500]" : ""} hover:font-[500]`} onClick={() => { navigate("/contact") }}>Contact</li>
                        </ul>
                    </Fade>
                </div>
                <div className="basis-[15%] cursor-pointer lg:hidden text-white text-3xl flex justify-end items-center " onClick={toggleNav}>
                    <AiOutlineMenu className='hover:text-4xl transition-all duration-100' />
                </div>
                <div className="hidden basis-[30%] md:flex gap-[20px] justify-end ">
                    <Fade right duration={1000} delay={800}>
                        <a href='https://github.com/Mazstar04' className=" bg-primary rounded-[18px] text-secondary hover:text-midnight hover:bg-secondary transition-all duration-500 cursor-pointer w-[60px] h-[60px] text-[1.7rem] flex items-center justify-center">
                            <AiFillGithub />
                        </a>
                    </Fade>
                    <Fade right duration={1000} delay={1000}>
                        <div className="w-[190px] h-[60px] flex justify-center items-center text-primary rounded-[14px] font-montserrat text-[16px] font-[500] cursor-pointer bg-[transparent] bg-gradient-to-r from-secondary to-text  hover:bg-gradient-to-l transition-all duration-[1000ms] whitespace-nowrap "
                            onClick={() => { navigate("/contact") }}>Contact Me</div>
                    </Fade>
                </div>

            </div>

        </>
    );
}

export default TopNavComponent;